module.exports = __webpack_public_path__ + "static/bills-252345465819af7acc4b1c08acbf2d55.svg";